module.exports = __webpack_public_path__ + "static/media/IMG-9.31706c50.jpg";